import './glossary.scss';

// The "all" filter targets the element wrapper itself, every other filter one letter group,
// so a single data-target comparison covers both cases.
function initGlossary(glossary) {
  const groups = glossary.querySelectorAll('.glossary-group');
  const filters = glossary.querySelectorAll('.glossary-link');

  for (const filter of filters) {
    filter.addEventListener('click', () => {
      const target = filter.dataset.target;

      for (const other of filters) {
        other.classList.toggle('glossary-link--active', other === filter);
      }

      for (const group of groups) {
        group.classList.toggle('hidden', target !== `#${glossary.id}` && target !== `#${group.id}`);
      }
    });
  }
}

// Scoped per element, so two glossaries on one page do not filter each other.
for (const glossary of document.querySelectorAll('[data-glossary]')) {
  initGlossary(glossary);
}
